import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "list-none p-2 m-2 surface-ground" }
const _hoisted_2 = { class: "flex justify-content-center align-items-center mt-2 mb-5" }
const _hoisted_3 = { class: "flex justify-content-center align-items-center mt-2 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ height: `${$data.vh - 170}px` }),
    class: "flex align-items-center justify-content-center pt-3 pb-3"
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        ($data.store.token != '' && ($data.store.user.department.id == 3 || $data.store.user.department.id == 2))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "javascript:void(0);",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.setRoute('mod-orders/orders')))
            }, [
              _createVNode(_component_PrimevueButton, {
                label: "OBJEDNÁVKY",
                severity: "primary",
                text: "",
                raised: "",
                class: "basic-menu"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", _hoisted_3, [
        ($data.store.token != '' && ($data.store.user.department.id == 3 || $data.store.user.department.id == 1))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "javascript:void(0);",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.setRoute('mod-stock')))
            }, [
              _createVNode(_component_PrimevueButton, {
                label: "SKLAD",
                severity: "primary",
                text: "",
                raised: "",
                class: "basic-menu"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 4))
}